import { httpBatchLink, loggerLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import type { TrpcRouter } from "server/routers";
import superjson from "superjson";
import { apiBaseurl } from "./apiBaseurl";
export const trpc = createTRPCReact<TrpcRouter>();
export const trpcClient = trpc.createClient({
  links: [
    loggerLink({
      enabled: (op) =>
        process.env.NODE_ENV === "development" ||
        (op.direction === "down" && op.result instanceof Error),
    }),
    httpBatchLink({
      url: `${apiBaseurl.get()}/api/trpc`,
      transformer: superjson,
      // Headers are automatically set by tRPC for batch requests
      // No need to manually set content-type
    }),
  ],
});
